import React from 'react';
import { Slide as SlideType } from '@/eventConfig/types.ts';
import { ConfirmDataEntryCheckbox } from '@/components/slides/DataSummary/components/ConfirmDataEntryCheckbox.tsx';
import { ConfigSlideId } from '@/eventConfig/types.ts';

export const ConfirmDataEntryCheckboxGB = ({ slide }: { slide: SlideType }) => {
  const slideIdsToValidate: ConfigSlideId[] = ['name', 'email', 'phone', 'address', 'birthdate', 'bmi', 'ancestry'];
  return <ConfirmDataEntryCheckbox slide={slide} slideIdsToValidate={slideIdsToValidate} />;
};
